module.exports = __webpack_public_path__ + "images/logo/peing_logo_06f19b7acac26723a0b3fdfd48a2f3b2.png";